package com.partejar.app.core.ui.theme

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.ReadOnlyComposable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember

object PartejarTheme {
    val colors: PartejarExtraColors
        @Composable
        @ReadOnlyComposable
        get() = LocalPartejarExtraColors.current

    val spacing: PartejarSpacing
        @Composable
        @ReadOnlyComposable
        get() = LocalPartejarSpacing.current

    val dimensions: PartejarDimensions
        @Composable
        @ReadOnlyComposable
        get() = LocalPartejarDimensions.current
}

@Composable
fun PartejarTheme(
    themeMode: ThemeMode = ThemeMode.SYSTEM,
    content: @Composable () -> Unit
) {
    val useDarkTheme = when (themeMode) {
        ThemeMode.SYSTEM -> isSystemInDarkTheme()
        ThemeMode.LIGHT -> false
        ThemeMode.DARK -> true
    }
    val statusBarOverride = remember { mutableStateOf<Boolean?>(null) }
    PartejarSystemBars(
        darkTheme = useDarkTheme,
        lightStatusBarIcons = statusBarOverride.value ?: useDarkTheme
    )
    val colorScheme = if (useDarkTheme) PartejarDarkColorScheme else PartejarLightColorScheme
    val extraColors = if (useDarkTheme) PartejarDarkExtraColors else PartejarLightExtraColors

    CompositionLocalProvider(
        LocalStatusBarOverride provides statusBarOverride,
        LocalPartejarExtraColors provides extraColors,
        LocalPartejarSpacing provides DefaultPartejarSpacing,
        LocalPartejarDimensions provides DefaultPartejarDimensions
    ) {
        MaterialTheme(
            colorScheme = colorScheme,
            typography = partejarTypography(),
            shapes = PartejarMaterialShapes,
            content = content
        )
    }
}
